export default "__VITE_ASSET__i1Vt7TB6__"